import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { loadTeam, addTeam, selectTeam } from "./teamSlice";
import CardTeam from "../../components/cardTeam/CardTeam";
import style from "./style.module.css";

const Team = () => {
  const teamState = useSelector(selectTeam);
  const dispatch = useDispatch();

  //renders on first time page load.
  useEffect(() => {
    dispatch(loadTeam());
  }, []);

  return (
    <>
      {/* Page-Banner section starts...*/}
      <section>
        <div className="pageBanner">
          <div className="bannerContent">
            <h1 className="page-banner-title">Our Team</h1>
          </div>
        </div>
      </section>
      {/* Page-Banner section ends...*/}

      <section className={style.directorsSection}>
        <CardTeam teamState={teamState} />
      </section>
    </>
  );
};

export default Team;
